import { render, staticRenderFns } from "./SupportersFeed.vue?vue&type=template&id=d347fe78&scoped=true&lang=html&"
import script from "./SupportersFeed.vue?vue&type=script&lang=js&"
export * from "./SupportersFeed.vue?vue&type=script&lang=js&"
import style0 from "./SupportersFeed.vue?vue&type=style&index=0&id=d347fe78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d347fe78",
  null
  
)

export default component.exports